const QuestionEditor = function ($scope, questionnaireInteractor) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.content = $ctrl.question.content;
    $ctrl.preamble = $ctrl.question.analysis_preamble;
    $ctrl.contentId = 'question_content_' + $ctrl.position;
    $ctrl.preambleId = 'question_preamble_' + $ctrl.position;
    $ctrl.options = $ctrl.question.options;
    setIsOptionsQuestion();
    setIsRangedQuestion();
    setQuestionTitle($ctrl.content);
  };

  $ctrl.saveContent = function (content) {
    return new Promise(resolve => {
      let questionData = angular.copy($ctrl.question);
      questionData.content = content;
      questionData.questionnaireId = $ctrl.questionnaireId;
      questionData.questionPosition = $ctrl.position;

      questionnaireInteractor.updateQuestionInQuestionnaire(
        questionData,
        () => {
          $ctrl.content = questionData.content;
          $ctrl.question.content = $ctrl.content;
          setQuestionTitle($ctrl.content);
          $scope.$digest();
          resolve();
        },
        () => {
          throw('Failed to save question content');
        }
      );
    });
  };

  $ctrl.savePreamble = function (content) {
    return new Promise(resolve => {
      let questionData = angular.copy($ctrl.question);
      questionData.analysis_preamble = content;
      questionData.questionnaireId = $ctrl.questionnaireId;
      questionData.questionPosition = $ctrl.position;

      questionnaireInteractor.updateQuestionInQuestionnaire(
        questionData,
        () => {
          $ctrl.preamble = questionData.analysis_preamble;
          $ctrl.question.analysis_preamble = $ctrl.preamble;
          $scope.$digest();
          resolve();
        },
        () => {
          throw('Failed to save question analysis preamble');
        }
      );
    });
  };

  $ctrl.onOptionUpdate = function (optionIndex, optionData) {
    return new Promise(resolve => {
      let questionData = angular.copy($ctrl.question);
      questionData.options[optionIndex] = angular.copy(optionData);
      questionData.questionnaireId = $ctrl.questionnaireId;
      questionData.questionPosition = $ctrl.position;

      questionnaireInteractor.updateQuestionInQuestionnaire(
        questionData,
        () => {
          $ctrl.options[optionIndex] = questionData.options[optionIndex];
          $ctrl.question.options = questionData.options;
          // $scope.$digest();
          resolve();
        },
        () => {
          throw('Failed to update question option');
        }
      );
    });
  };

  $ctrl.addNewOption = function () {
    let questionData = angular.copy($ctrl.question);
    questionData.options.push({
      content: '',
      analysis: ''
    });
    questionData.questionnaireId = $ctrl.questionnaireId;
    questionData.questionPosition = $ctrl.position;

    questionnaireInteractor.updateQuestionInQuestionnaire(
      questionData,
      function () {
        $ctrl.options = questionData.options;
        $ctrl.question.options = questionData.options;
        $scope.$digest();
      },
      function () {
        alert('Failed to Add option to question');
      }
    );
  };

  $ctrl.deleteOption = function (optionIndex) {
    let confirmed = window.confirm("Are you sure that you want to delete this option? You won't be able to recover it.");

    if (confirmed) {
      let questionData = angular.copy($ctrl.question);
      questionData.options.splice(optionIndex, 1);
      questionData.questionnaireId = $ctrl.questionnaireId;
      questionData.questionPosition = $ctrl.position;

      questionnaireInteractor.updateQuestionInQuestionnaire(
        questionData,
        function () {
          $ctrl.options = questionData.options;
          $ctrl.question.options = questionData.options;
          $scope.$digest();
        },
        function () {
          alert('Failed to delete option from question');
        }
      );
    }
  };

  $ctrl.moveOption = function (optionIndex, changeInPosition) {
    let questionData = angular.copy($ctrl.question);
    questionData.questionnaireId = $ctrl.questionnaireId;
    questionData.questionPosition = $ctrl.position;

    let option = $ctrl.options[optionIndex];
    questionData.options.splice(optionIndex, 1);
    questionData.options.splice(optionIndex + changeInPosition, 0, option);

    questionnaireInteractor.updateQuestionInQuestionnaire(
      questionData,
      function () {
        $ctrl.options = questionData.options;
        $ctrl.question.options = questionData.options;
        $scope.$digest();
      },
      function () {
        alert('Failed to reposition option');
      }
    );
  };

  $ctrl.onRangeInfoChange = function (newRangeInfo) {
    let questionData = angular.copy($ctrl.question);
    questionData.range_info = newRangeInfo;
    questionData.questionnaireId = $ctrl.questionnaireId;
    questionData.questionPosition = $ctrl.position;

    // console.log(newRangeInfo);

    questionnaireInteractor.updateQuestionInQuestionnaire(
      questionData,
      function () {
        $ctrl.question.range_info = questionData.range_info;
        $scope.$digest();
      },
      function () {
        alert('Failed to update slider settings');
        $scope.$digest();
      }
    );
  };

  function setQuestionTitle(str) {
    $ctrl.questionTitle = htmlStrippedStr(str);
  }

  function htmlStrippedStr(str) {
    let div = document.createElement("div");
    div.innerHTML = str;
    return div.textContent || div.innerText || "";
  }

  function setIsOptionsQuestion() {
    $ctrl.isOptionsQuestion = $ctrl.question.question_type == 'checkbox' || $ctrl.question.question_type == 'radio';
  }

  function setIsRangedQuestion() {
    $ctrl.isRangedQuestion = $ctrl.question.question_type == 'range';
  }
};

export default {
  name: 'questionEditor',
  obj: {
    controller: QuestionEditor,
    templateUrl: 'components/question_editor.html',
    bindings: {
      question: '<',
      questionnaireId: '<',
      position: '<'
    }
  }
};